import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Card, Grid, Statistic } from "semantic-ui-react";
import { Text } from "..";
import { COLORS } from "../../../constants";
import { CurrenecyText } from "../text";

interface IValueList {
    label: string;
    value: number;
}

interface ISummaryCardType2 extends WithTranslation {
    labelHeader?: string;
    valueList: IValueList[];
    unit: string;
    noneBorderRadius?: boolean;
    fluid?: boolean;
}

class SummaryCardType2 extends Component<ISummaryCardType2> {
    public render() {
        const {
            labelHeader,
            valueList,
            noneBorderRadius,
            fluid,
            t,
        } = this.props;
        const borderRadius = noneBorderRadius ? styles.card : undefined;
        return (
            <Card style={borderRadius} centered fluid={fluid}>
                <Card.Content
                    header={<Text size="huge">{labelHeader}</Text>}
                    style={styles.headerCard}
                />
                <Card.Content
                    style={styles.bodyCard}
                    description={

                        <Grid
                            stackable
                            doubling
                            columns={"equal"}
                            celled
                            style={styles.descriptionCard}
                            textAlign="center">
                            {valueList.length > 0 ?
                                <Grid.Row columns={"3"}>
                                    {
                                        valueList.map((data: IValueList, index: number) => {
                                            return (
                                                <Grid.Column key={index} style={styles.borderStyle}>
                                                    {this.renderCard(data.label, data.value)}
                                                </Grid.Column>
                                            );
                                        })
                                    }
                                </Grid.Row>
                                :
                                <Grid.Row>
                                    <Grid.Column>
                                        <Text>{t("SummaryCardType2.noData")}</Text>
                                    </Grid.Column>
                                </Grid.Row>
                            }
                        </Grid>

                    }
                />
            </Card>
        );
    }

    private renderCard = (label?: string, value?: number) => {
        const { unit } = this.props;
        return (
            <Statistic size="mini">
                <Statistic.Label>
                    <Text size="medium">{label}</Text>
                </Statistic.Label>
                <Statistic.Value>
                    <CurrenecyText pureValue>
                        {value || 0}
                    </CurrenecyText>
                </Statistic.Value>
                <Statistic.Label>
                    <Text size="medium">{`(${unit})`}</Text>
                </Statistic.Label>
            </Statistic>
        );
    }
}

const styles = {
    headerCard: {
        background: "#F3F3F3",
        textAlign: "center",
    },
    bodyCard: {
        padding: 0,
    },
    descriptionCard: {
        margin: 0,
    },
    card: {
        borderRadius: "initial",
    },
    borderStyle: {
        border: `1px solid ${COLORS.borderLightGrey}`,
        // borderBottom: `1px solid ${COLORS.borderDarkGrey}`,
    },
};

export default withTranslation()(SummaryCardType2);
